import React from 'react';
import '../styles/Footer.css';

export default function Footer() {
  return (
    <footer className="footer fixed-footer bg-white text-muted">
      <div className="container text-center small py-2">
        <div>
          © {new Date().getFullYear()} Habibtea — Made with 💚 in Chicago   | Developed by <a href="https://www.quantumxgroup.com" target="_blank" rel="noopener noreferrer">QuantumX Group LLC. All rights reserved.</a>
        </div>
      </div>
    </footer>
  );
}
